// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { BusinessFormationSdkConfig } from '@legalzoom/business-formation-sdk/lib/core/business-formation-configuration/business-formation.configuration.model';
import { CommonLibConfig } from '@legalzoom/common-sdk';
import { CheckoutLibConfig } from '@legalzoom/lib-checkout';

export const environment = {
  production: true,
  useGloTheme: false,
  testKenshoo: false,
  llcStartPageUrl: '/name/change-name/',
  checkoutUrl: '/lzweb/handlers/Checkouthandler.ashx',
  cartBillingItemsUrl: '/lzweb/handlers/PackageDetailsHandler.ashx?mode=billingitems',
  getCartUrl: '/lzweb/handlers/GetCart.ashx',
  postCartUrl: '/lzweb/handlers/PostCart.ashx',
  getPackagesUrl: '/lzweb/handlers/PackageSelection.ashx',
  guestPassSignInUrl: '/LZWeb/Handlers/GuestPassSignIn.ashx',
  saveQuestionnaireUrl: '/BrainNET/Handlers/SaveQuestionnaireData.ashx',
  setQuestionnaireUrl: '/BrainNET/Handlers/SetQuestionnaire.ashx',
  getQuestionnaireUrl: '/BrainNET/Handlers/GetQuestionnaire.ashx',
  getSEMTrackingUrl: '/lzweb/handlers/SEMTracking.ashx',
  getSetOrderCompleteUrl: '/lzweb/handlers/SetOrderComplete.ashx',
  getEmailHandlerUrl: '/lzweb/handlers/EmailHandler.ashx',
  getTaggingHandlerUrl: '/lzweb/handlers/TaggingHandler.ashx',
  getPostCheckoutUrl: '/lzweb/handlers/PostCheckoutHandler.ashx',
  getExpressOrderUrl: '/lzweb/handlers/CreateExpressOrder.ashx',
  setPackageItemURL: '/lzweb/handlers/SetCartPackageItem.ashx',
  applyDiscountUrl: '/LZWeb/PackageDetails/v1.0/ApplyDiscount',
  isBusinessNameAvailableUrl: 'https://api.legalzoom.com/v1/business-name-check/names/{0}/states/{1}',
  businessActivitiesUrl: '/sites/lz.com/views/uuid/llc?_format=json',
  businessActivityUrl: '/sites/lz.com/rest/{0}',
  filingFeesUrl: '/sites/lz.com/views/uuid/filingfees?_format=json',
  filingFeeUrl: '/sites/lz.com/rest/{0}',
  addressAutocompleteUrl: 'https://api.legalzoom.com/v1/address-validation/autocomplete',
  addressValidationUrl: 'https://api.legalzoom.com/v1/address-validation',
  accessKey: '5365C320-DF73-4C3A-87CC-BA3F6ECF78B2',
  lzApiKey: 'VHUX4it2avZGhAXqPB7ryTaH0QYAzPYZ',
  timestringCookie: 'LZAuthCookie',
  tealium: {
    ACCOUNT: 'legalzoom',
    PROFILE: 'main',
    ENVIRONMENT: 'prod'
  },
  kenshooID: '7055e9bc-b680-4f54-98e0-c9d5ec92d9a6',
  kenshooUrl: 'https://www.legalzoom.com/sem/ep/poa.html'
    + '?kid=7055e9bc-b680-4f54-98e0-c9d5ec92d9a6'
    + '&utm_source=bing'
    + '&utm_medium=cpc'
    + '&utm_term=power_of_attorney'
    + '&utm_content=7055e9bc-b680-4f54-98e0-c9d5ec92d9a6'
    + '&utm_campaign=EP_|_PoA'
    + '&utm_id=bing_283097089_1246846223391236_77927941476845_kwd-77927916112800:loc-190_c'
    + '&msclkid=f59c5e4e409810f5756b04ffdc55a848',
  optimizelyUrl: '',
  geoLocationUrl: '/LZWeb/Handlers/geolocationhandler.ashx'
};

export const environmentNew: BusinessFormationSdkConfig = {
  baseUrl: 'https://api.legalzoom.com',
  caasUrl: '',
  lzApiKeyWebSession: 'xge9Xc7mKeOG4Q8vuVMJHGAu8i74hGA2',
  lzApiKey: 'VHUX4it2avZGhAXqPB7ryTaH0QYAzPYZ',
  production: false,
  testKenshoo: true,
  tealium: {
    ACCOUNT: 'legalzoom',
    PROFILE: 'main',
    ENVIRONMENT: 'qa'
  },
  kenshooID: '7055e9bc-b680-4f54-98e0-c9d5ec92d9a6',
  kenshooUrl: 'https://www.legalzoom.com/sem/ep/poa.html'
    + '?kid=7055e9bc-b680-4f54-98e0-c9d5ec92d9a6'
    + '&utm_source=bing'
    + '&utm_medium=cpc'
    + '&utm_term=power_of_attorney'
    + '&utm_content=7055e9bc-b680-4f54-98e0-c9d5ec92d9a6'
    + '&utm_campaign=EP_|_PoA'
    + '&utm_id=bing_283097089_1246846223391236_77927941476845_kwd-77927916112800:loc-190_c'
    + '&msclkid=f59c5e4e409810f5756b04ffdc55a848',
  timestringCookie: 'LZAuthCookie',
  userIdentificationCookie: 'LZUserIdentification',
  customerCookie: 'TIMESTRING'
};

export const environmentCommon: CommonLibConfig = {
  baseUrl: 'https://api.legalzoom.com',
  caasUrl: 'https://www.legalzoom.com',
  lzApiKeyWebSession: 'xge9Xc7mKeOG4Q8vuVMJHGAu8i74hGA2',
  lzApiKey: 'VHUX4it2avZGhAXqPB7ryTaH0QYAzPYZ',
  authMethod: '',
  tokenLocation: 'LZUserIdentification',
  refreshTokenLocation: 'LZUserIdentification',
};

export const environmentGC: CheckoutLibConfig = {
  baseUrl: 'https://api.legalzoom.com',
  caasUrl: 'https://www.legalzoom.com',
  lzApiKeyWebSession: 'xge9Xc7mKeOG4Q8vuVMJHGAu8i74hGA2',
  lzApiKeyAddressAutocomplete: 'VHUX4it2avZGhAXqPB7ryTaH0QYAzPYZ',
  tealium: {
    account: 'legalzoom',
    profile: 'main',
    environment: 'prod'
  },
  gcPageData: {
    desktopPhoneNumber: '(855) 787-1221',
    mobilePhoneNumber: '8557871203',
    title: 'LLC',
    phoneTooltip: `
    Mon-Fri 5am to 7pm PT
    Weekends 7am to 4pm PT
  `,
    processId: 2,
    questionnaireId: 27
  },
  logConfiguration: {
    applicationId: '0eb543bf-0137-4fe4-a398-42fa2e54379c',
    clientToken: 'pub3905dc452a8594d0deca8f04b76bb6b1',
    site: 'datadoghq.com',
    sampleRate: 100,
    trackInteractions: true,
    silentMultipleInit: true
  }
}